module.exports = __webpack_public_path__ + "img/footer_logo.2990e0e6.png";